import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Careers.css';
import JobList from './JobList';
import { fetchCareers } from '../firebase/firestoreService';

export default function Career() {
  const [visible, setVisible] = useState('');
  const [careers, setCareers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleToggle = (section) => {
    setVisible(visible === section ? '' : section);
  };

  const handleApplyNow = () => {
    navigate('/application');
  };

  // Fetch careers from Firestore
  useEffect(() => {
    const loadCareers = async () => {
      try {
        setLoading(true);
        setError(null);
        const careersData = await fetchCareers();
        setCareers(careersData);
      } catch (err) {
        console.error('Error loading careers:', err);
        setError('Failed to load job listings. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    loadCareers();
  }, []);

  return (
    <div className="career-page">
      <section className="career-header">
        <h2>Join Our Creative Team</h2>
        <p className="career-subtitle">Shape the future of horror gaming with us</p>
        
        <div className="career-cards">
          <div className="career-card" onClick={() => handleToggle('mission')}>
            <h3>OUR MISSION</h3>
            <p>Pushing the boundaries of horror storytelling through innovative technology and creative excellence</p>
            {visible === 'mission' && (
              <div className="card-details">
                <p>We are dedicated to creating immersive horror experiences that challenge conventional storytelling. Our mission is to blend cutting-edge technology with masterful narrative craft to deliver unforgettable experiences that leave lasting impressions on our audience.</p>
                <ul>
                  <li>Innovation in horror gaming and media</li>
                  <li>Pushing creative boundaries</li>
                  <li>Delivering exceptional user experiences</li>
                  <li>Building a community of horror enthusiasts</li>
                </ul>
              </div>
            )}
          </div>

          <div className="career-card" onClick={() => handleToggle('culture')}>
            <h3>TEAM CULTURE</h3>
            <p>A collaborative environment where creativity thrives and every voice matters</p>
            {visible === 'culture' && (
              <div className="card-details">
                <p>Our team is built on the foundation of mutual respect, creative freedom, and shared passion for horror storytelling. We believe in fostering an environment where ideas flourish and innovation is encouraged.</p>
                <ul>
                  <li>Open communication and collaboration</li>
                  <li>Creative freedom and experimentation</li>
                  <li>Continuous learning and growth</li>
                  <li>Work-life balance and flexibility</li>
                  <li>Diverse perspectives and inclusive environment</li>
                </ul>
              </div>
            )}
          </div>

          <div className="career-card" onClick={() => handleToggle('benefits')}>
            <h3>BENEFITS & PERKS</h3>
            <p>Comprehensive benefits package designed to support your personal and professional growth</p>
            {visible === 'benefits' && (
              <div className="card-details">
                <p>We believe in taking care of our team members with a comprehensive benefits package that goes beyond the basics.</p>
                <ul>
                  <li>Competitive salary and performance bonuses</li>
                  <li>Flexible remote work options</li>
                  <li>Health, dental, and vision insurance</li>
                  <li>Professional development budget</li>
                  <li>Unlimited PTO and mental health days</li>
                  <li>Latest hardware and software tools</li>
                  <li>Team building events and retreats</li>
                  <li>Gaming and entertainment allowances</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="job-section">
        <h3>Open Positions</h3>
        <p className="job-section-subtitle">Find your perfect role in our growing team</p>
        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading job listings...</p>
          </div>
        ) : error ? (
          <div className="error-container">
            <p className="error-message">{error}</p>
            <button 
              className="retry-btn" 
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        ) : (
          <JobList careers={careers} />
        )}
      </section>

      <section className="apply-section">
        <div className="apply-content">
          <h3>Ready to Join Our Team?</h3>
          <p>Ready to create amazing horror experiences? Fill out the application form and let's build something incredible together.</p>
          <button className="apply-now-btn" onClick={handleApplyNow}>
            Apply Now
          </button>
        </div>
      </section>
    </div>
  );
}
